import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/learn/glossary',
}).lazy(() => import('./glossary.lazy').then((d) => d.Route))
